import React from 'react';
import { Box, Typography } from '@mui/material';

const PanelSwag = () => {


  return (
    <Box sx={{ backgroundColor: (theme) => theme.palette.secondary.main, color: (theme) => theme.palette.text.main, padding: 2 }}>
      <Typography variant="h4" sx={{ marginBottom: 3 }}>FAQ</Typography>
      
      <Box>
        <Typography variant="h6" sx={{ marginBottom: 1 }}>Link Would go Here in go-live</Typography>
      </Box>
    </Box>
  );
};

export default PanelSwag;